import React from 'react';
import { Player } from 'video-react';
import '../../node_modules/video-react/dist/video-react.css';
import BigPlayButton from 'video-react/lib/components/BigPlayButton';
import NavBar from './NavBar';
import '../styles/VideoplayPage.css';
import { Checkbox, Avatar, Button } from '@material-ui/core';
import {
  ThumbUpOutlined,
  ThumbDownAltOutlined,
  Share,
} from '@material-ui/icons';
import Footer from './Footer';
import CommentSection from './CommentSection';
import SuggestionCard from './SuggestionCard';

import saved_list from '../assets/saved_list.png';

const VideoPlayerPage = () => {
  return (
    <>
      <NavBar />
      <div className="videopage">
        <div className="videoplaypage">
          <div className="vidoeplaypage__left">
            <Player
              playsInline
              src="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4"
            >
              <BigPlayButton position="center" />
            </Player>

            <div className="videoplaypage__title">
              <h1>Video Title</h1>
              <h4>Description</h4>
              <div className="title__view">
                <h3>500 views</h3>
                <div className="checkbox__div">
                  <Button>Up Next</Button>
                  <Checkbox
                    className="checkbox"
                    inputProps={{ 'aria-label': 'uncontrolled-checkbox' }}
                  />
                  <h3>Auto Play</h3>
                </div>
              </div>
            </div>

            <div className="videoplaypage__likeshare">
              <ThumbUpOutlined />
              <h3>850</h3>
              <ThumbDownAltOutlined />
              <h3>100</h3>
              <Share />
              <h3>Share</h3>
              <img
                src={saved_list}
                className="videoplaypage__save_list"
                alt="save_list"
              />
              <h3>Save </h3>
            </div>

            {/* Commetns__Part */}

            <h2 className="comments">4 Comments</h2>

            <div className="comment__div">
              <Avatar src="" />
              <input
                type="text"
                placeholder="Write Comment..."
                className="comment__input"
              />
            </div>
            <CommentSection />
            <CommentSection />
            <CommentSection />
          </div>

          {/* Suggestion__Part */}

          <div className="videoplaypage__right">
            <div className="add_div">
              <h1>ADD</h1>
            </div>
            <div className="suggestion__colume">
              <SuggestionCard />
              <SuggestionCard />
              <SuggestionCard />
              <SuggestionCard />
              <SuggestionCard />
            </div>
          </div>
        </div>

        {/* Footer */}
        <Footer />
      </div>
    </>
  );
};

export default VideoPlayerPage;
